require("@rails/ujs").start()

import 'bootstrap/js/src/alert.js'
import 'bootstrap/js/src/carousel.js'
import 'bootstrap/js/src/dropdown.js'

import './stylesheets/application.scss'
import './stylesheets/home.scss'
import './stylesheets/mixes.scss'
import './stylesheets/nav.scss'
import './stylesheets/sharing.scss'
import './stylesheets/sidebar.scss'

import '@trevoreyre/autocomplete-vue/dist/style.css'
import 'bootstrap/scss/bootstrap.scss'
import 'vue-select/dist/vue-select.css'

import './javascript/fontawesome.js'
import './javascript/toast_handler.js'

require('./javascript/mixmastermiles')

globalThis.__VUE_OPTIONS_API__ = true
globalThis.__VUE_PROD_DEVTOOLS__ = false
globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

import LocalTime from "local-time"
LocalTime.start()
